// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"7492":"13d108d2","8056":"e9974904"}[chunkId] || chunkId) + "." + {"346":"545a2f9f090041c5","5094":"243fde518c27aebc","7492":"32f962c4d2f84fcf","8056":"269b0290e07d7343"}[chunkId] + ".js";
};